/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiLocationsQueryFromJSON(json) {
    return ApiLocationsQueryFromJSONTyped(json, false);
}
export function ApiLocationsQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pagetypes': !exists(json, 'pagetypes') ? undefined : json['pagetypes'],
    };
}
export function ApiLocationsQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'page': value.page,
        'pagetypes': value.pagetypes,
    };
}
